import { render, staticRenderFns } from "./Attendees.vue?vue&type=template&id=61bdce5a&scoped=true"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"
import style0 from "./Attendees.vue?vue&type=style&index=0&id=61bdce5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdce5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
